module.exports = __webpack_public_path__ + "static/img/female-bg-ar.55dc10ef.png";